import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "src/app/components/components.module";
import { WithdrawalECheckAddPage } from "./withdrawal-echeck-add";

@NgModule({
    declarations: [
        WithdrawalECheckAddPage,
    ],
    imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
    ],
})
export class WithdrawalECheckAddPageModule { }
